import { render, staticRenderFns } from "./XuatKho.vue?vue&type=template&id=5cd8b80b&scoped=true&"
import script from "./XuatKho.vue?vue&type=script&lang=js&"
export * from "./XuatKho.vue?vue&type=script&lang=js&"
import style0 from "./XuatKho.vue?vue&type=style&index=0&id=5cd8b80b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd8b80b",
  null
  
)

export default component.exports